import styled from 'styled-components'

interface SpaceProps {
  vertical: number | string
  inline?: boolean
}

export default styled.div`
  height: ${({ vertical }: SpaceProps) => vertical + (typeof vertical === 'number' ? 'px' : '')};
  display: ${({ inline }: SpaceProps) => inline ? 'inline' : 'block' };
`



// WEBPACK FOOTER //
// ./src/components/atoms/Space.tsx